module.exports = __webpack_public_path__ + "img/editor_preview-3.1409099.webp";